import { render } from "./GroupTreeSegment.vue?vue&type=template&id=89c0bfdc&ts=true"
import script from "./GroupTreeSegment.vue?vue&type=script&lang=ts"
export * from "./GroupTreeSegment.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__